module.exports = __webpack_public_path__ + "img/zoran_tomic.2e5f4a5e.png";